// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"transform-3"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.5 7H7M7 7H17V17M7 7L7 17L17 17M7 7L7 3.5M17 17V20.5M17 17H20.5M7.60938 16.3906L20 4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Transform3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'transform-3',
    ref,
    icon: element,
  },
));

Transform3Icon.displayName = 'Transform3Icon';

export default Transform3Icon;
